import React, { Component } from 'react';
import Modal from 'react-modal';
import CognitoUtil from '../../aws/cognito/cognitoUtil';
import Events from '../../common/events';
import globals from 'APP_ROOT/components/common/globals';
import { strings, getCurrentLocale } from '../../../localization';
import Analytics from 'APP_ROOT/services/analytics';
import PasswordPolicyChecklist from '../../common/passwordPolicyChecklist';

export default class ChangePasswordModal extends Component {

    constructor(props) {

        super(props);
        this.state = {
            changePasswordResponseMessage: null,
            validateOldPwMessage: null,
            validateNewPwMessage: null,
            validateConfirmNewMessage: null,
            termsAccepted: false,
            termsAcceptanceRequiredMessage: null,
            validationFailed: false,
            newPassword: "",
            isNewPasswordValid: false
        };
    }

    afterChangePasswordModalOpened = (e) => {
        Analytics.modalView('/changePasswordModal');
    }

    onNewPasswordChange = (e) => {      
        this.setState({ 
            newPassword: e.target.value
        });
    }

    onChangePasswordSubmit = (e) => {

        e.preventDefault();
        if (this.validateForm()) {
            document.dispatchEvent(new CustomEvent(Events.SHOW_LOADING_PAGE, { detail: { loadingPageMessage: strings.formatString(strings.reset_pw_updating) } }));
            if(this.props.cognitoNewPasswordRequired)
            {
                CognitoUtil.completeNewPasswordChallenge(this.newPassword.value, 
                    this.props.onChangePasswordSuccess, (e) => {
                        this.reportErrorToUser(e);
                        document.dispatchEvent(new CustomEvent(Events.HIDE_LOADING_PAGE));
                    }
                );
            }
            else
            {
                var op = this.props.op;
                if(!op) op = this.oldPassword.value;
                CognitoUtil.changePassword(op,
                    this.newPassword.value, 
                    this.props.onChangePasswordSuccess, (e) => {
                        this.reportErrorToUser(e);
                        document.dispatchEvent(new CustomEvent(Events.HIDE_LOADING_PAGE));
                    }
                );
        
            }
        }
    }

    reportErrorToUser = (e) => {

        console.log("New Pass Fail", e);
        // usually get something like InvalidPasswordException: "Password does not conform to policy: Password not long enough"

        var message = strings.formatString(strings.reset_pw_error_unknown);

        // TODO - translate password error message?
        if(e.code === "InvalidParameterException" || e.code === "NotAuthorizedException")
        {
            if(this.props.oldPasswordRequired)
                message = "Old password incorrect or new password does not conform to policy";
            else
                message = "New password does not conform to policy";
        }
        else if(e.code === "InvalidPasswordException")
        {
            message = e.message;
        }

        this.setState({
            changePasswordResponseMessage: message
        });
    }

    validateForm() {

        var oldPasswordV = this.props.oldPasswordRequired ? this.oldPassword.value.length > 0 : true;
        var termsAcceptance = this.props.acceptTermsRequired ? this.state.termsAccepted : true;
        var newPasswordV = this.newPassword.value.length > 0;
        var confirmNewPasswordV = this.confirmNewPassword.value.length > 0;
        var newPasswordMatch = this.newPassword.value === this.confirmNewPassword.value;
        if (oldPasswordV && newPasswordV && confirmNewPasswordV && newPasswordMatch && termsAcceptance) {
            this.setState({
                validateOldPwMessage: null,
                validateNewPwMessage: null,
                validateConfirmNewMessage: null,
                changePasswordResponseMessage: null,
            });
            return true;
        } else {
            var oldPwMessage = oldPasswordV === true ? null : strings.formatString(strings.signup_error_required);
            var newPwMessage = newPasswordV === true ? null : strings.formatString(strings.signup_error_required);
            var confirmNewPwMessage = confirmNewPasswordV === true ? null : strings.formatString(strings.signup_error_required);
            var newPwMatchMessage = newPasswordMatch === true ? null : strings.formatString(strings.password_error_match)
            let termsAcceptanceRequiredMessage = termsAcceptance ? null : strings.signup_error_required;

            this.setState({
                validateOldPwMessage: oldPwMessage,
                validateNewPwMessage: newPwMessage ? newPwMessage : newPwMatchMessage,
                validateConfirmNewMessage: confirmNewPwMessage ? confirmNewPwMessage : newPwMatchMessage,
                changePasswordResponseMessage: null,
                termsAcceptanceRequiredMessage: termsAcceptanceRequiredMessage
            });
            return false;
        }
    }

    render() {

        var changePasswordMessage = null;
        if (this.state.changePasswordResponseMessage)
            changePasswordMessage = <p className="error-message no-margin"><i className="material-icons">error</i><span>{this.state.changePasswordResponseMessage}</span></p>;


        var oldPwMessage = this.state.validateOldPwMessage ?
            <p className="error-message">{this.state.validateOldPwMessage}</p> :
            <p className="error-message">&nbsp;</p>;
        var newPwMessage = this.state.validateNewPwMessage ?
            <p className="error-message">{this.state.validateNewPwMessage}</p> :
            <p className="error-message">&nbsp;</p>;
        var confirmNewPwMessage = this.state.validateConfirmNewMessage ?
            <p className="error-message">{this.state.validateConfirmNewMessage}</p> :
            <p className="error-message">&nbsp;</p>;
        return (
            <Modal
                isOpen={this.props.accountPage.state.changePasswordModalOpen}
                contentLabel="edit-plan-modal"
                className="react-modal-content react-modal-sm"
                overlayClassName="react-modal-overlay"
                onRequestClose={this.props.accountPage.closeChangePasswordModalOpen}
                onAfterOpen={this.afterChangePasswordModalOpened}>

                <div className="container-fluid form-card">

                    
                    {
                    this.props.title ?
                        <h2> { this.props.title }</h2>
                         :
                        <h2>
                            <i className="material-icons">edit</i>
                            {
                                this.props.newPasswordRequired ? 
                                    strings.formatString(strings.new_pw_title) : 
                                    strings.formatString(strings.forgot_password_update_password)
                            }
                        </h2>
                    }

                    {this.props.message ?
                        this.props.message :
                        <p>{this.props.newPasswordRequired ? strings.formatString(strings.password_new_description) : strings.formatString(strings.password_update_description)}</p>
                    }

                    <div className="row">

                        <div className="col-12">
                            <form className="row" onSubmit={this.onChangePasswordSubmit}>

                                { this.props.oldPasswordRequired ? 
                                    <div className="col-12 col-sm-6">
                                        <label htmlFor="oldPassword">{strings.formatString(strings.password_old_title)}</label>
                                        <input id="oldPassword" ref={(oldPassword) => { this.oldPassword = oldPassword }} type="password" placeholder="******" />
                                        {oldPwMessage}
                                    </div>
                                    : null
                                }

                                <div className="col-12"></div>

                                <div className="col-12 col-sm-6">
                                    <label htmlFor="newPassword">{strings.formatString(strings.password_new_title)}</label>
                                    <input id="newPassword" ref={(newPassword) => { this.newPassword = newPassword }} type="password" placeholder="******" value={this.state.newPassword} onChange={this.onNewPasswordChange} />
                                    {newPwMessage}
                                </div>

                                <div className="col-12 col-sm-6">
                                    <label htmlFor="confirmNewPassword">{strings.formatString(strings.password_new_confirm_title)}</label>
                                    <input id="confirmNewPassword" ref={(confirmNewPassword) => { this.confirmNewPassword = confirmNewPassword }} type="password" placeholder="******" />
                                    {confirmNewPwMessage}
                                </div>

                                { this.props.acceptTermsRequired ?
                                    <div className="col-12 terms-checkbox-wrapper">
                                        <input type="checkbox" checked={this.state.termsAccepted} name="termsAccepted" onChange={() => {this.setState({termsAccepted: !this.state.termsAccepted});}}/>
                                        <label htmlFor="termsAccepted" className="checkbox-label">{strings.user_sign_up_i_agree} <a href={globals.eulaUrl + '#' + getCurrentLocale()} target="_blank" alt={strings.eula}>{strings.terms_of_service}</a></label>
                                        <div className="error-message">{this.state.termsAcceptanceRequiredMessage}</div>
                                    </div>
                                :
                                    null
                                }

                                {this.props.submessage ?
                                    this.props.submessage :
                                    null
                                }

                                <div className="col-12 col-sm-6 mt-3">
                                    <PasswordPolicyChecklist password={this.state.newPassword} onPolicyCheck={(result) => { if(result !== this.state.isNewPasswordValid) this.setState({isNewPasswordValid: result})}} />
                                </div>

                                <div className="col-12 col-sm-6 action-btns text-right">
                                    {changePasswordMessage }
                                    <button className="btn btn-outline-blue" onClick={this.props.accountPage.closeChangePasswordModal}><i className="material-icons">close</i>{strings.formatString(strings.storage_cancel_action)}</button>
                                    <button className="btn" disabled={!this.state.isNewPasswordValid}><i className="material-icons">check</i>{strings.formatString(strings.btn_title_change)}</button>
                                </div>
                            </form>
                        </div>

                    </div>
                </div>
            </Modal>
        );
    }
}
